import { graphql } from 'react-relay';
export type { IsKlarnaEligibleQuery as IsKlarnaEligibleQueryType } from './__generated__/IsKlarnaEligibleQuery.graphql';

export const isKlarnaEligibleQuery = graphql`
    query IsKlarnaEligibleQuery(
        $itemId: String = ""
        $userId: String
        $userCurrency: String = ""
        $amount: String = ""
        $userCountry: String = ""
    ) {
        viewer {
            item(itemId: $itemId, pageType: PDP) {
                isKlarnaEligible: isPaymentMethodEligible(
                    buyerId: $userId
                    paymentMethod: KLARNA
                    currency: $userCurrency
                    amount: $amount
                    userCountry: $userCountry
                )
            }
        }
    }
`;
